import { useEffect, useMemo, useRef } from "react"
import { useMutation } from "@apollo/client"
import { EVENT_VIEWS_MUTATION } from "@graphql"
import { debounce } from "lodash"
import dayjs from "dayjs"
import utc from "dayjs/plugin/utc"
import PropTypes from "prop-types"

dayjs.extend(utc)

const INTERVAL_DELAY = 2 * 60 * 1000 // 2 minutes

const EventViewsTracker = ({ children, eventId = null }) => {
  const lastActiveAtRef = useRef(null)
  const [createEventView] = useMutation(EVENT_VIEWS_MUTATION)

  const updateLastActiveAt = useMemo(() => debounce(() => {
    lastActiveAtRef.current = dayjs.utc().format("YYYY-MM-DD HH:mm:ss")
  }, 500), []) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    createEventView({ variables: { input: { event_id: eventId, type: "STAFF", last_active_at: dayjs.utc().format("YYYY-MM-DD HH:mm:ss") } } })
  }, [createEventView, eventId])

  useEffect(() => {
    const events = ["mousemove", "mousedown", "keypress", "scroll", "touchstart"]

    events.forEach(event =>
      window.addEventListener(event, updateLastActiveAt)
    )

    return () => {
      events.forEach(event =>
        window.removeEventListener(event, updateLastActiveAt)
      )
    }
  }, [updateLastActiveAt])

  useEffect(() => {
    const interval = setInterval(() => {
      const lastActive = lastActiveAtRef.current
      
      lastActiveAtRef.current = null

      if (lastActive !== null) {
        createEventView({ variables: { input: { event_id: eventId, type: "STAFF", last_active_at: lastActive } } })
      }
    }, INTERVAL_DELAY)

    return () => clearInterval(interval)
  }, [createEventView, eventId])
  
  return <>{children}</>
}

EventViewsTracker.propTypes = {
  eventId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}

export default EventViewsTracker
